import { render } from "./PrimeDataTable.vue?vue&type=template&id=e1289930&scoped=true"
import script from "./PrimeDataTable.vue?vue&type=script&lang=js"
export * from "./PrimeDataTable.vue?vue&type=script&lang=js"

import "./PrimeDataTable.vue?vue&type=style&index=0&id=e1289930&lang=css"
import "./PrimeDataTable.vue?vue&type=style&index=1&id=e1289930&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/@vue+cli-service@5.0.9_@vue+compiler-sfc@3.5.26_lodash@4.17.21_sass-loader@13.3.3_node-_2efde1b6c902023e3f10239734cd10e2/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1289930"]])

export default __exports__